import React, { memo } from 'react';
import { useIntl } from 'umi';

import useFullScreen from '@home/components/FullScreenScale/_hooks/useFullScreen';
import SvgIcon from '@home/components/SvgIcon';

import CardIconButton from '../CardIconButton';

import './index.scss';

export interface IFullscreenIconButtonProps {
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onToggle?: (next: boolean) => void;
  enterIconType?: string;
  /**
   * 外部决定“全屏哪个元素”（直接传 ref，和 TableTragCard 一致）。
   */
  target: React.RefObject<HTMLElement | null>;
  onError?: (error: unknown) => void;
}

const FullscreenIconButton: React.FC<IFullscreenIconButtonProps> = (props) => {
  const {
    className,
    style,
    disabled = false,
    onToggle,
    enterIconType = 'fullscreen',
    target,
  } = props;
  const { isFullScreen, requestFullScreen } = useFullScreen(target, onToggle);
  const { formatMessage } = useIntl();
  return (
    <CardIconButton
      className={className}
      style={{
        display: isFullScreen ? 'none' : 'inline-flex',
        ...style,
      }}
      disabled={disabled}
      onClick={requestFullScreen}
      bubbleProps={{
        content: formatMessage({ id: 'dbl_common_fullscreen' }),
        popupContainer: isFullScreen ? (target.current || undefined) : undefined,
      }}
    >
      <SvgIcon type={enterIconType} className="dbl-fullscreen-icon-button__icon" />
    </CardIconButton>
  );
};

export default memo(FullscreenIconButton);
